import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Task } from '../../addons/task/task.model';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { AvatarModule } from 'primeng/avatar';
import { CardModule } from 'primeng/card';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-task-card',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    TagModule,
    AvatarModule,
    CardModule,
    TooltipModule
  ],
  templateUrl: './task-card.component.html',
  styleUrls: ['./task-card.component.css']
})
export class TaskCardComponent {
  @Input() task!: Task;
  @Output() viewTask = new EventEmitter<Task>();
  @Output() completeTask = new EventEmitter<Task>();

  constructor(private router: Router) { }

  getPrioritySeverity(priority: string): string {
    switch (priority) {
      case 'High':
        return 'danger';
      case 'Medium':
        return 'warning';
      case 'Low':
        return 'info';
      default:
        return 'secondary';
    }
  }

  onViewTask(): void {
    if (this.task.routerLink) {
      this.router.navigate(this.task.routerLink);
    }
    this.viewTask.emit(this.task);
  }

  onCompleteTask(): void {
    this.completeTask.emit(this.task);
  }
}
